<template>
  <div class="main" style="background-color: #fff;">
    <!-- 轮播图 -->
    <div class="u-flex u-row-center banner" :style="{ backgroundImage: 'url(' + page_img + ')' }"
      style="background-size: cover;">
      <div class="container">
        <div class="info">
        </div>
      </div>
    </div>
    <div class="introduce">
      <div class="u-flex u-col-top container">
        <div class="u-flex-col tab">
          <div class="u-flex item" :class="{ 'active': tabIndex === index }" v-for="(item, index) in tabList"
            :key="index" @click="onTab(index, item)">{{ item }}
          </div>
        </div>

                 <div class="content" v-if="!loading">
           <h3>{{ title }} </h3>
           <div class="mt20 u-flex u-flex-wrap u-row-between feature" v-if="content">
             <dl class="u-flex u-col-top">
               <dd v-html="content">
               </dd>
             </dl>
           </div>
           <div v-else class="no-data">
             <p>暂无数据</p>
           </div>
         </div>
         <div v-else class="loading">
           <p>加载中...</p>
         </div>

      </div>
    </div>
    <div class="container">
      <div class="free-use">
        <span>免费试用</span>
        <p>看完介绍还是不熟悉?没关系，联系客服免费体验</p>
        <el-button class="contact" type="primary" round size="small">联系客服</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Index',
  data() {
    return {
      tabIndex: 0,
      title: "产品介绍",
      tabList: ["产品简介", "产品特点", "使用场景"],
      checkList: [],
      page_img: '',
      cid: 0,
             content: '',
       introduceData: {

       },
       loading: false

    }
  },
  computed: {
    type() {
      return this.$route.query.type
    }
  },
  mounted() {

  },
  created() {
    this.initData()
  },
  watch: {
    '$route.query.id': {
      handler(newId) {
        if (newId) {
          this.initData()
        }
      },
      immediate: true
    }
  },
  methods: {
    initData() {
      // 重置数据到初始状态
      this.introduceData = this.$options.data().introduceData
      this.tabIndex = 0
      this.content = ''
      this.title = "产品介绍"
      this.page_img = ''
      
      // 获取新的产品ID
      const id = this.$route.query.id
      if (id) {
        this.getIntroduceDetail(id)
      }
    },
    getIntroduceDetail(id) {
      this.loading = true
      this.$api.goods.getIntroduceDetail({ id: id }).then(res => {
        this.introduceData = res.data.list
        this.page_img = res.data.page_img
        this.onTab(0)
      }).catch(error => {
        console.error('获取产品详情失败:', error)
        this.$message.error('获取产品信息失败')
      }).finally(() => {
        this.loading = false
      })
    },
    onTab(index) {
      this.title = this.tabList[index]
      this.tabIndex = index

      if (index == 0) {
        this.content = this.introduceData.product_introduction
      } else if (index == 1) {
        this.content = this.introduceData.characteristic
      } else if (index == 2) {
        this.content = this.introduceData.usage_scenario
      }
    },
  }
}
</script>

<style scoped>
.banner {
  margin-top: 80px;
  width: 100%;
  height: 300px;
  color: #457ff6;
  background: url(../assets/images/cpjs_bg1.png) no-repeat;
}

.banner .name {
  font-size: 32px;
}

.banner p {
  margin-top: 10px;
  font-size: 16px;
}

.buy {
  margin-top: 30px !important;
  background: #2682ff;
}

.tab {
  width: 320px;
  background: #f1f5f8;
}

.tab .item {
  width: 320px;
  height: 60px;
  line-height: 60px;
  font-size: 16px;
}

.tab .item::before {
  margin-right: 20px;
  content: '';
  height: 30px;
  width: 4px;
  display: block;
}

.tab .active {
  color: #2682ff;
  background: #fdfffe;
}

.tab .active::before {
  background: #2682ff;
}

.introduce {
  padding: 20px 0;
}

.content {
  margin-left: 20px;
  height: 500px;
}

.content h3 {
  color: #2682ff;
  font-size: 18px;
}

.article {
  margin-top: 20px;
  padding: 16px 10px 32px;
  background: #f1f5f8;
  border-radius: 4px;
}

.article h4 {
  font-size: 16px;
  font-weight: 400;
}

.article p {
  margin-top: 10px;
  line-height: 28px;
  color: #666;
  font-size: 14px;
}

.use {
  margin-top: 20px !important;
  padding: 12px 30px;
  background: #2682ff;
}

.el-icon-caret-right {
  margin-left: 4px;
}

.free-use {
  margin: 100px 0 20px;
  padding: 20px 0;
  color: #fff;
  text-align: center;
  border-radius: 8px;
  background: url(../assets/images/cpjs_pic1.png) no-repeat 100%;
}

.free-use span {
  font-size: 20px;
}

.free-use p {
  padding: 10px 0;
  font-size: 14px;
}

.contact {
  padding: 12px 30px;
  color: #2682ff;
  font-size: 14px;
  background: #fff;
}

.feature dl {
  min-width: 1000px;
  max-width: 1000px;
  margin: 0 20px 20px 0;
  padding: 20px;
  /**!SECTION    width: calc(50% - 10px); */
  border-radius: 4px;
  box-sizing: border-box;
  background: #f1f5f8;
}

.feature dl:nth-of-type(2n) {
  margin-right: 0;
}

.feature dl dt img {
  margin-top: 10px;
  width: 36px;
  height: 36px;
}

.feature dl dd {
  margin-left: 16px;
  color: #999;
  font-size: 14px;
}

.feature dl dd h4 {
  color: #000;
  font-size: 16px;
}

.feature dl dd p {
  margin-top: 4px;
  line-height: 24px;
  font-size: 14px;
}

.scenarios {
  padding: 20px 20px 50px;
  border-radius: 8px;
  background: #f1f5f8;
}

.scenarios h4 {
  margin-bottom: 10px;
  color: #000;
  font-size: 16px;
}

.scenarios p {
  line-height: 24px;
  color: #999;
  font-size: 14px;
}

.loading, .no-data {
  text-align: center;
  padding: 50px 0;
  color: #999;
  font-size: 14px;
}

.loading p, .no-data p {
  margin: 0;
}
</style>
